// @flow
import * as React from 'react';
import type { PermitDocument as PermitDocumentType } from 'esm-web-pro/types/networks';
import PermitDocument from 'esm-web-pro/components/pages/network/PermitDocument';
import { isEmpty } from 'lodash';
import ContentRow from 'esm-web-pro/components/layout/sidePanel/ContentRow';
import ValueText from 'esm-web-pro/components/layout/sidePanel/ValueText';
import { FormattedMessage } from 'react-intl';

type Props = {
    documents: Array<PermitDocumentType>,
    reload: Function,
    buildName?: Function,
};

const PermitDocumentList = (props: Props) => {
    const { documents, reload, buildName } = props;

    return !isEmpty(documents) ? documents.map((document) => (
        <PermitDocument key={document.id} document={document} reload={reload} buildName={buildName} />
    )) : (
        <ContentRow padLevel={1}>
            <ValueText>
                <FormattedMessage id="no-permit-documents" defaultMessage="No permit documents" />
            </ValueText>
        </ContentRow>
    );
};

PermitDocumentList.defaultProps = {
    buildName: undefined,
};

export default PermitDocumentList;
